import {combineReducers} from 'redux';
import settings from './settings/reducer';
import menu from './menu/reducer';
import authUser from './authUser/reducer';
import general from './general/reducer';
import app from './app/reducer';

const reducers = combineReducers({
  menu,
  settings,
  authUser,
  general,
  app,
});

export default reducers;
